import { createAsyncThunk } from '@reduxjs/toolkit'
import { ExploreQueryParam } from '@shared/Services/QueryParamService'
import { IExploreSliceState, IReduxThunkArg, IReduxThunkReturned } from './redux.types'
import ExploreMediaService from '@internal/services/explore-media'

export const fetchExploreThunk = createAsyncThunk<IReduxThunkReturned, IReduxThunkArg | undefined>('fetchExploreThunk', async (_, thunkAPI) => {
  const state = thunkAPI.getState() as { ExploreSlice: IExploreSliceState }
  const filter = { ...state.ExploreSlice.filterThunk }

  const res = await ExploreMediaService.initialWithGraphql(filter, thunkAPI.signal)

  filter.pagination = { ...(filter.pagination ?? ExploreMediaService.defaultFilterPagination), total: res.totalMedias }
  ExploreQueryParam.Set(filter)
  return { products: res.medias, categories: res.categories, prices: res.prices, filter, totalProducts: res.totalMedias }
})

export const fetchExploreFilterThunk = createAsyncThunk<Omit<IReduxThunkReturned, 'prices'>>('fetchExploreFilterThunk', async (_, thunkAPI) => {
  const state = thunkAPI.getState() as { ExploreSlice: IExploreSliceState }
  const filter = { ...state.ExploreSlice.filterThunk }
  const res = await ExploreMediaService.allWithGraphql(filter, thunkAPI.signal)

  filter.pagination = { ...(filter.pagination ?? ExploreMediaService.defaultFilterPagination), total: res.totalMedias }
  ExploreQueryParam.Set(filter)
  return { products: res.medias, categories: res.categories, filter }
})
